const selectors = {
    el: '.js-select:not(.is-initialized)',
};

const init = () => {
    const els = document.querySelectorAll(selectors.el);

    const updateWidth = select => {
        const span = document.createElement('span');
        span.style.position = 'absolute';
        span.style.whiteSpace = 'nowrap';
        span.textContent = select.options[select.selectedIndex].text;
        select.parentNode.appendChild(span);

        requestAnimationFrame(() => {
            const newWidth = span.clientWidth + 10;
            select.style.width = `${newWidth}px`;
            span.remove();
        });
    };

    els.forEach(select => {
        select.classList.add('is-initialized');

        updateWidth(select);
        select.addEventListener('change', () => updateWidth(select));
        window.addEventListener('resize', () => {
            updateWidth(select);
        });
    });
};

const module = () => {
    window.addEventListener('load', init);
    document.addEventListener('domUpdated', init);
};

export default module;
